import { render, staticRenderFns } from "./inventoryInfo.vue?vue&type=template&id=050fa24a&scoped=true&"
import script from "./inventoryInfo.vue?vue&type=script&lang=js&"
export * from "./inventoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./inventoryInfo.vue?vue&type=style&index=0&id=050fa24a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050fa24a",
  null
  
)

export default component.exports